"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var CalibrationImage = /** @class */ (function (_super) {
    __extends(CalibrationImage, _super);
    function CalibrationImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: true
        };
        return _this;
    }
    CalibrationImage.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.url !== this.props.url) {
            this.setState({
                isLoading: true
            });
        }
    };
    CalibrationImage.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Spinner, { color: "secondary", hidden: !this.state.isLoading }),
            React.createElement("img", { id: "calibrationBarcode", alt: "Calibration barcode", width: this.props.width, height: this.props.height, src: this.props.url, hidden: this.state.isLoading, onLoad: function () { _this.setState({ isLoading: false }); } })));
    };
    return CalibrationImage;
}(React.Component));
exports.CalibrationImage = CalibrationImage;
//# sourceMappingURL=CalibrationImage.js.map